import React from "react";
import { ButtonVariant } from "../../../../config/colors";
import { Button, ButtonSize } from "../../../../components/Button";

interface SendTxTemplateProps {
    onButtonClick: () => void;
    buttonDisabled?: boolean;
    buttonLoading?: boolean;
    children?: React.ReactNode;
    blocks?: React.ReactNode[];
    error?: string;
    buttonVariant?: ButtonVariant;
    buttonText?: string;
    className?: string;
    afterButton?: React.ReactNode;
}

const SendTxTemplate: React.FC<SendTxTemplateProps> = ({ 
    onButtonClick, 
    buttonDisabled, 
    buttonLoading, 
    children, 
    blocks, 
    error,
    buttonVariant = ButtonVariant.primary,
    buttonText = 'CONTINUE',
    className = '',
    afterButton = null,
}) => {
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if(! buttonDisabled)
            onButtonClick();
    }
    
    return (
        <form className="flex-1 px-4 flex flex-col justify-center items-center" onSubmit={handleSubmit} autoComplete="off">
            <div className={`flex flex-col items-stretch gap-6 max-w-[500px] w-full ${className ? className : 'justify-center'}`}>
                {
                    children && (
                        <div className="bg-brand-bg-2 rounded-xl p-4 flex flex-col">
                            {children}
                        </div>
                    )
                }
                
                {blocks && blocks.map((block, index) => (
                    <div className="bg-brand-bg-2 rounded-xl p-4 flex flex-col" key={index}>
                        {block}
                    </div>
                ))}

                {error && error !== '' && <div className="text-brand-red text-center">{error}</div>}

                <div>
                    <Button
                        variant={buttonVariant}
                        size={ButtonSize.large}
                        disabled={buttonDisabled}
                        loading={buttonLoading}
                        type="submit"
                    >
                        {buttonText}
                    </Button>
                </div>

                {afterButton}
            </div>
        </form>
    );
}

export default SendTxTemplate;